import { Action } from 'shared/store/types';
import actions from './actionTypes';
import { SearchSuggestion } from 'types/searchSuggestion';
import { SearchSuggestionsState } from './types';

export const defaultState: SearchSuggestionsState = {
  productSuggestions: [],
  otherSuggestions: [],
  trendingSearches: [],
  searchAutoSuggestions: [],
  isPopularSuggestionLoaded: false,
  popularSuggestionTypes: [],
  recentlyViewed: [],
  searchField: '',
  showVoiceModal: false,
  isSearchWidgetLoading: false,
  isSearchWidgetError: false,
  searchSuggestionWidgets: null,
  remaining_inventories_ids: [],
};

const searchSuggestionsReducer = (state = defaultState, action: Action) => {
  const { type, payload } = action;

  switch (type) {
    case actions.FETCH_SEARCH_SUGGESTION: {
      if (state.searchField === action.searchInput) {
        const productSuggestions = payload.filter(
          (obj: SearchSuggestion) => obj.type === 'product'
        );
        const otherSuggestions = payload.filter(
          (obj: SearchSuggestion) => obj.type !== 'product'
        );
        const searchAutoSuggestions = payload;
        return {
          ...state,
          productSuggestions,
          otherSuggestions,
          searchAutoSuggestions,
        };
      }
      return state;
    }

    case actions.FETCH_TRENDING_SEARCHES:
      return { ...state, trendingSearches: payload };

    case actions.FETCH_POPULAR_SUGGESTIONS:
      return {
        ...state,
        isPopularSuggestionLoaded: true,
        popularSuggestionTypes: payload,
      };

    case actions.FETCH_POPULAR_SUGGESTIONS_FAIL:
      return { ...state, isPopularSuggestionLoaded: true };

    case actions.UPDATE_SEARCH_FIELD:
      return { ...state, searchField: payload };

    case actions.RESET_SEARCH:
      return {
        ...defaultState,
      };
    case actions.TOGGLE_VOICE_Modal:
      return { ...state, showVoiceModal: payload };

    case actions.FETCH_RECENTLY_VIEWED_PRODUCTS:
      return { ...state, recentlyViewed: payload };

    case actions.FETCH_SEARCH_SUGGESTION_WIDGETS_PROGRESS:
      return { ...state, isSearchWidgetLoading: true };

    case actions.FETCH_SEARCH_SUGGESTION_WIDGETS_SUCCESS: {
      const { widgets, remaining_inventories_ids } = payload;
      return {
        ...state,
        searchSuggestionWidgets: widgets,
        remaining_inventories_ids,
        isSearchWidgetLoading: false,
      };
    }
    case actions.FETCH_SEARCH_SUGGESTION_WIDGETS_FAIL:
      return {
        ...state,
        isSearchWidgetLoading: false,
        isSearchWidgetError: false,
      };
    default:
      return state;
  }
};

export default searchSuggestionsReducer;
